import React from 'react';
import './ConversationEvent.scss';
import MessageDate from './MessageDate';

const ConversationEvent = ({ message }) => {
  const { content, received_at } = message;
  return (
    <div className="ConversationEvent">
      <span>{content}</span>
      <MessageDate received_at={received_at} />
    </div>
  );
};

export default ConversationEvent;
